import { GenerateExperienceRecommendationEndpoint } from '@kouto/types';
import { z } from 'zod';
import { post } from 'utils/axios';
import ApiResponse from '../types/ApiResponse';

export type GenerateListingRecommendationsRequest = z.infer<
  typeof GenerateExperienceRecommendationEndpoint.requestSchema
>;
export type GenerateListingRecommendationsResponse = z.infer<
  typeof GenerateExperienceRecommendationEndpoint.responseSchema
>;

const generateListingRecommendations = async (
  brandId: string,
  body: GenerateListingRecommendationsRequest,
) => {
  const url = GenerateExperienceRecommendationEndpoint.url({});
  const response = await post<
    ApiResponse<GenerateListingRecommendationsResponse>,
    GenerateListingRecommendationsRequest
  >(url, body, {
    headers: {
      'Kouto-Brand-Id': brandId,
    },
  });
  return response.data;
};

export default generateListingRecommendations;
